<template>
  <v-card class="card-container">
    <div class="main-toolbar mb-2">
      <div class="icon-back">
        <v-img
          src="../../../assets/figmaIcons/white/contracts.svg"
          max-width="55%"
        ></v-img>
      </div>

      <span class="main-toolbar-title">
        {{ $t('Repositório Central de Arquivos') }}
      </span>
      <v-spacer></v-spacer>

      <div v-if="!isLoading">
        <div class="subtitle-item justify-end mb-1">
          <span>Total: {{ allFilesSize }}MB</span>
        </div>
        <div style="width: 100%" class="d-flex align-center">
          <v-progress-linear
            :value="uploadPercentage"
            :buffer-value="100"
            :indeterminate="isLoading"
            background-color="primary"
            color="secondary"
            height="10"
            class="rounded-progress-bar"
          >
            <template v-slot:default></template>
          </v-progress-linear>
        </div>
        <div class="subtitle-container mt-2">
          <div class="subtitle-item">
            <span class="color-circle color-upload d-flex align-center"></span>
            <span>Área comum: {{ commonAreafilesSize }}MB</span>
          </div>
          <div class="subtitle-item">
            <span class="color-circle color-buffer"></span>
            <span>Arquivos diversos: {{ uploadDocumentsFilesSize }}MB</span>
          </div>
        </div>
      </div>

      <div v-else class="d-flex justify-center align-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>

    <div>
      <v-tabs
        color="secondary"
        v-model="tab"
        :height="40"
        :mobile-break-point="300"
        class="ma-auto"
        icons-and-text
      >
        <v-tabs-slider color="#BBCF20"></v-tabs-slider>

        <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0">
          {{ $t('Ordem de Serviço') }}
          <img
            src="../../../assets/figmaIcons/green/servOrder.svg"
            alt="Equip"
            style="object-fit: contain"
            class="ma-1 mr-2"
          />
        </v-tab>

        <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0">
          {{ $t('Equipamentos') }}
          <img
            src="../../../assets/figmaIcons/green/equips.svg"
            alt="Equip"
            style="object-fit: contain"
            class="ma-1 mr-2"
          />
        </v-tab>

        <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0">
          {{ $t('Contratos') }}
          <img
            src="../../../assets/figmaIcons/green/contracts.svg"
            alt="Equip"
            style="object-fit: contain"
            class="ma-1 mr-2"
          />
        </v-tab>
        <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0">
          {{ $t('Padrões de Calibração') }}
          <img
            src="../../../assets/figmaIcons/green/calib.svg"
            alt="Equip"
            style="object-fit: contain"
            class="ma-1 mr-2"
          />
        </v-tab>
        <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0">
          {{ $t('Área Comum') }}
          <img
            src="../../../assets/figmaIcons/green/common.svg"
            alt="Equip"
            style="object-fit: contain"
            class="ma-1 mr-2"
          />
        </v-tab>
        <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0">
          {{ $t('Custo Evitado') }}
          <img
            src="../../../assets/figmaIcons/green/AvoidedCost.svg"
            alt="Equip"
            style="object-fit: contain"
            class="ma-1 mr-2"
          />
        </v-tab>
        <v-tab
          v-if="this.institution?.showManuais || user.mainType == 0"
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
        >
          {{ $t('Manual de Equipamentos') }}
          <img
            src="../../../assets/figmaIcons/green/standequip.svg"
            alt="Equip"
            style="object-fit: contain"
            class="ma-1 mr-2"
          />
        </v-tab>
        <v-tab
          v-if="
            this.institution?.showEngClinic ||
            this.institution?.showEngInfra ||
            user.mainType == 0
          "
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
        >
          {{ $t('POPs') }}
          <img
            src="../../../assets/figmaIcons/green/reports.svg"
            alt="Equip"
            style="object-fit: contain"
            class="ma-1 mr-2"
          />
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item><Orders /></v-tab-item>
        <v-tab-item><Equips /></v-tab-item>
        <v-tab-item><Contracts /></v-tab-item>
        <v-tab-item><Patterns /></v-tab-item>
        <v-tab-item><Common @totalFilesUpdate="sumFiles" /></v-tab-item>
        <v-tab-item><AvoidedCosts /></v-tab-item>

        <!-- Manual de Equipamentos -->
        <v-tab-item v-if="institution?.showManuais || user.mainType == 0">
          <ManualTabs />
        </v-tab-item>

        <!-- POPs -->
        <v-tab-item
          v-if="
            institution?.showEngClinic ||
            institution?.showEngInfra ||
            user.mainType == 0
          "
        >
          <Pops />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-card>
</template>

<script>
import Orders from './components/orders.vue'
import Equips from './components/equips.vue'
import Contracts from './components/contracts.vue'
import Patterns from './components/patterns.vue'
import Common from './components/common.vue'
import Pops from './components/Pops.vue'
import ApiService from '../../../services/ApiService'
import ManualTabs from './components/ManualTabs.vue'
import AvoidedCosts from './components/avoidedCosts.vue'

export default {
  name: 'FilesRepository',

  components: {
    Orders,
    Equips,
    Contracts,
    Patterns,
    Common,
    ManualTabs,
    Pops,
    AvoidedCosts,
  },

  data() {
    return {
      tab: 0,
      visible: false,
      commonAreafilesSize: 0,
      uploadDocumentsFilesSize: 0,
      allFilesSize: 0,
      apiService: new ApiService(),
      isLoading: false,
      institution: {},
      user: {},
    }
  },

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution')) || {}
    this.user = JSON.parse(localStorage.getItem('user')) || {}
    this.sumFiles()

    if (this.$route.query.tab) {
      const urlTab = parseInt(this.$route.query.tab)
      if (
        urlTab === 6 &&
        !this.institution.showManuais &&
        this.user.mainType !== 0
      ) {
        this.tab = 6
      } else if (urlTab === 7 && this.institution.showManuais) {
        this.tab = 7
      } else {
        this.tab = urlTab
      }
    }
  },

  watch: {
    '$route.query.tab'(newVal) {
      if (newVal !== undefined) {
        const urlTab = parseInt(newVal)

        if (
          urlTab === 6 &&
          !this.institution.showManuais &&
          this.user.mainType !== 0
        ) {
          this.tab = 6
        } else if (urlTab === 7 && this.institution.showManuais) {
          this.tab = 7
        } else {
          this.tab = urlTab
        }
      }
    },
  },
  computed: {
    uploadPercentage() {
      if (this.allFilesSize > 0) {
        return (this.commonAreafilesSize / this.allFilesSize) * 100
      }
      return 0
    },
  },
  methods: {
    async sumFiles() {
      this.isLoading = true
      const institutionId = JSON.parse(localStorage.getItem('institution')).id
      this.apiService
        .get(`CommonAreaDocument/sum-files-size?institutionId=${institutionId}`)
        .then((response) => {
          const {
            commonAreafilesSize,
            uploadDocumentsFilesSize,
            allFilesSize,
          } = response.content || {}

          this.commonAreafilesSize = commonAreafilesSize
          this.uploadDocumentsFilesSize = uploadDocumentsFilesSize
          this.allFilesSize = allFilesSize
          this.isLoading = false
        })
    },
  },
}
</script>

<style>
.rounded-progress-bar {
  border-radius: 12px;
  overflow: hidden;
}
.subtitle-container {
  display: flex;
  gap: 20px;
  margin-top: 10px;
}

.subtitle-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.color-circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.color-upload {
  background-color: #b9ce1e;
}

.color-buffer {
  background-color: #0f3565;
}
.color-total {
  background-color: #686868;
}
</style>
